<template lang="pug"
src='./glazing-in-existing.pug'>

</template>

<script>
import _ from 'lodash'
import saveBtn from '@/common/components/saveBtn.vue'
import imgIcon from '@/common/img/baseline-clear-24px.svg'

export default {
	name: 'glazing',
	props: ['project', 'control', 'readonly', 'findControlTextByKey'],
	components: { saveBtn },
	data () {
		return {
			imgIconDel: imgIcon,
			windowTypes: {
				operable: 'Operable Windows',
				fixed: 'Fixed Windows',
				sliding: 'Sliding Glass Doors',
				french: 'French Doors',
				skylights: 'Skylights'
			},
			specialGlassDefault: {
				toBeReplaced: true,
				toBeAdded: false,
				type: 'OP1, OPERABLE',	// Operable
				area: 0.0,
				orient: 0,	// default Front
				degFront: 0 // Degrees, clockwise from Front
			},
			windowDefault: {
				existUnch: [
					{ orient: 0, value: 0.0 },
					{ orient: 90, value: 0.0 },
					{ orient: 180, value: 0.0 },
					{ orient: 270, value: 0.0 }
				],
				toBeReplaced: [
					{ orient: 0, value: 0.0 },
					{ orient: 90, value: 0.0 },
					{ orient: 180, value: 0.0 },
					{ orient: 270, value: 0.0 }
				],
				toBeAdded: [
					{ orient: 0, value: '' },
					{ orient: 90, value: '' },
					{ orient: 180, value: '' },
					{ orient: 270, value: '' }
				],
				existFrame: 'AL',
				existGlazing: 'CLEAR.SNGL'
			}
		}
	},
	methods: {
		addSpecialGlass () {
			// Add special glass to project
			this.project.glazingInExisting.special.push(this.specialGlassDefault)
		},
		handleWindChange (event, index) {
			console.log('handleWindChange', event, index)
			const window = this.project.glazingInExisting.windows[index]
			if (event) {
				if (_.isNil(this.project.glazingInExisting.windows[index].existUnch)) {
					this.project.glazingInExisting.windows[index] = _.merge(window, this.windowDefault)
				}
			}
		},
		deleteSpecialGlazing (index) {
			this.project.glazingInExisting.special.splice(index, 1)
		},
		allWindowsAreEnabled () {
			let Windows = this.project.glazingInExisting.windows
			return _.every(Windows, ['enabled', false])
		},
		isWindowsGlassInExisting () {
			if (!this.project.glazingInExisting.windows[0].enabled && this.project.glazingInExisting.windows[1].enabled && this.project.glazingInExisting.windows[2].enabled !== true && this.project.glazingInExisting.windows[3].enabled !== true && this.project.glazingInExisting.windows[4].enabled !== true) {
				return true
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/tabs-components/glazing-in-existing.vue